import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const AIWithEcommerceSection = lazy(() => import("./AIWithEcommerceSection"));
const WorkSection = lazy(() => import("./WorkSection"));
const FeatureSection = lazy(() => import("./FeatureSection"));

const Ecommerce = () => {
  return (
    <main className="bg-white">
      <Helmet>
        <title>
          AI-Powered E-Commerce Platform | Personalized Shopping & Smart
          Solutions
        </title>

        <meta
          name="description"
          content="Transform your shopping experience with LENTERA’s AI-powered e-commerce platform. Enjoy personalized recommendations, visual search, AI chat support, dynamic pricing, smart inventory alerts and secure, seamless transactions."
        />

        <meta
          name="keywords"
          content="LENTERA e-commerce solutions, AI-driven shopping platform, real-time stock alerts, fraud detection in e-commerce, intelligent shopping assistant."
        />
      </Helmet>

      <HeroSection />

      <Suspense
        fallback={
          <div
            role="status"
            aria-live="polite"
            className="h-[400px] flex items-center justify-center"
          >
            Loading...
          </div>
        }
      >
        <AIWithEcommerceSection />
        <WorkSection />
        <FeatureSection />
      </Suspense>
    </main>
  );
};

export default Ecommerce;